import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { ChatState } from '../context';
import "./Mainloader.css"

function MainLoader() {
    const {MainLoader,setMainLoader,PublicLoader, setPublicLoader} = ChatState()
    const [visible,setVisible] = useState(true)
    const LoadData = () =>{
        setTimeout(()=>{

            if(MainLoader === 100){
                setMainLoader(0)
            }else if(PublicLoader === 100){
                setPublicLoader(0)
            }
        },2000)
    }
    useEffect(()=>{
        LoadData()
    },[MainLoader||PublicLoader])
  return (
    <>
    {visible?
    (
        
        <div className="progress-loader">
    <div className="progress" style={{width:`${MainLoader !== 0 ?MainLoader :PublicLoader}%`}}></div>
        
</div>
    )
    :""}
    </>
  )
}

export default MainLoader